import React from 'react';
import './Header.scss';
import ArrowSvg from '../../../../../prod/images/_arrow.svg?react';
import dompurify from 'dompurify';
import classNames from 'classnames';

const MegaMenuMobile = ({ megaMenuModel, active, selectedMain, selectedSub, setSelectedMain, setSelectedSub }) => {
  // temp fix - it would be better to use some 'local config in other places' 
  dompurify.removeAllHooks();
  
  const handleSelectMainClick = (evt, mainNav) => {
    evt.preventDefault();
    setSelectedMain(mainNav);
  }

  const handleSelectSubClick = (evt, subNav) => {
    evt.preventDefault();
    setSelectedSub(subNav);
  }

  return (
    <div className={classNames('fixed bg-[#d3ecda] w-full transform transition-transform duration-300 overflow-hidden left-0 right-0 bottom-0 top-[120px] p-12 pt-8 z-10 text-[#29588c]', active ? 'translate-x-0' : 'translate-x-full')}>
      { selectedMain === null && (
        <ul> {megaMenuModel?.items?.map(item => 
          <li className='py-5 border-b border-[#29588c] flex justify-between items-center cursor-pointer' onClick={(evt) => handleSelectMainClick(evt, item)} key={item.id}>
            <h2 className='text-2xl text-[#29588c] font-normal m-0'>{item.linkTitle}</h2>
            <ArrowSvg className='w-4 h-full' />
          </li>
        )}
        </ul>
      )}
      { selectedMain !== null && selectedSub === null && (
          <ul>
            <li className='py-2 border-b border-[#29588c] flex justify-between items-center' >
              <a className='hover:underline' href={selectedMain?.linkUrl}><h2 className='text-xl text-[#29588c] font-bold m-0'>{selectedMain?.linkTitle}</h2></a>
              <div className='flex items-center cursor-pointer hover:underline' onClick={(evt) => handleSelectMainClick(evt, null)}>
                <span className='mr-3 text-xl'>Back</span>
                <ArrowSvg className='w-4 h-full' />
              </div>
            </li> 
            { selectedMain?.editorialBlocks?.map(item =>
              <li className='py-2 border-b border-[#29588c] flex justify-between items-center cursor-pointer' onClick={evt => handleSelectSubClick(evt, item)} key={item.id}>
                <h2 className='text-xl text-[#29588c] font-normal m-0'>{item.title}</h2>
                <ArrowSvg className='w-4 h-full' />
              </li>
            )}
          </ul>
      )}
      { selectedSub !== null && (
        <div>
          <div className='py-2 border-b border-[#29588c] flex justify-between items-center'>
            <h2 className='text-xl text-[#29588c] font-bold m-0'>{selectedSub.title}</h2>
            <div className='flex items-center cursor-pointer hover:underline' onClick={(evt) => handleSelectSubClick(evt, null)}>
              <span className='mr-3 text-xl'>Back</span>
              <ArrowSvg className='w-4 h-full' />
            </div>
          </div>
          <div className='editorial-block-content-mobile' dangerouslySetInnerHTML={{ __html: dompurify.sanitize(selectedSub?.text) }} />
        </div>
      )}
    </div>
  )
}

export default MegaMenuMobile;